import { useQueryClient } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { ExamTypesCard } from "../components/exams";
import { AttendanceStatusesCard, ErrorTypesCard } from "../components/catalogs";
import { LiveTimeoutsCard } from "../components/live-timeouts";
import { WhatsAppSettingsCard } from "../components/whatsapp-settings";
import { AttendanceDayCard, HolidaysCard } from "../components/attendance-day";
import { RegistrationCard } from "../components/registration-setting";
import { ErrorNote, PageTitle, useSubmit } from "../components/ui";
import { errorText, send } from "../lib/api";
import { useOrg } from "../lib/org";

export function SettingsPage() {
  const org = useOrg();
  const qc = useQueryClient();
  const { busy, error, run } = useSubmit();
  if (!org) return null;

  function toggle(genderSeparation: boolean) {
    void run(async () => {
      await send("PATCH", `/v1/organizations/${org!.id}/settings`, { genderSeparation });
      await qc.invalidateQueries({ queryKey: ["organizations"] });
    }, errorText);
  }

  return (
    <>
      <PageTitle title="الإعدادات" sub={org.name} />
      <ErrorNote error={error} />
      <WhatsAppSettingsCard organizationId={org.id} />
      <section className="card">
        <div className="card-h">
          <h2>الفصل بين الجنسين في الحلقات</h2>
        </div>
        <div className="section">
          <label className="check">
            <input
              type="checkbox"
              checked={org.settings.genderSeparation}
              disabled={busy}
              onChange={(e) => toggle(e.target.checked)}
            />
            الحلقة المخصصة لجنس واحد لا تقبل إلا معلمين وطلابًا من الجنس نفسه
          </label>
          <p className="muted small">
            <b>الأثر:</b> عند التفعيل يرفض النظام (في الخادم وقاعدة البيانات) إسناد معلم أو تسجيل طالب يخالف
            فئة الحلقة، أو لم يُحدد جنسه. الحلقات «المختلطة / غير المحددة» لا تتأثر. التعطيل لا يغيّر أي تسجيل
            قائم.
          </p>
        </div>
      </section>
      <section className="card">
        <div className="card-h">
          <h2>سياسات البرامج</h2>
        </div>
        <div className="section">
          <p className="muted">
            المقادير، والمراجعة، وأيام الدراسة، والدرجات، وإعادة التسميع، والغياب، ومدة تعديل النتائج — تُضبط
            لكل مستوى (الجمعية، البرنامج، المجمع، الحلقة) من صفحة <Link to="/policies">سياسات البرامج</Link>.
            أي قيمة لم تعتمدها الجمعية تظهر بعلامة «إعداد أولي غير معتمد».
          </p>
        </div>
      </section>
      <ErrorTypesCard organizationId={org.id} />
      <AttendanceStatusesCard organizationId={org.id} />
      <AttendanceDayCard
        key={`att-${org.settings.attendance.dayCutoffHour}`}
        organizationId={org.id}
        value={org.settings.attendance}
      />
      <HolidaysCard organizationId={org.id} />
      <RegistrationCard
        key={`reg-${org.settings.registration.reviewMultiple}`}
        organizationId={org.id}
        value={org.settings.registration}
      />
      <LiveTimeoutsCard
        key={JSON.stringify(org.settings.liveTimeouts)}
        organizationId={org.id}
        value={org.settings.liveTimeouts}
      />
      <ExamTypesCard organizationId={org.id} />
    </>
  );
}
